// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"12e8d378","179":"0d113837","453":"51de2d63"}[chunkId] + ".chunk.css";
};